<template>
  <div class="container">
    <TopNav class="mt-4" />
    <GoogleAnalyticsIntegration />
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import GoogleAnalyticsIntegration from '@/web/components/settings/GoogleAnalyticsIntegration.vue';

export default Vue.extend({
  components: {
    TopNav,
    GoogleAnalyticsIntegration,
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
